import { BUTTON_SIZE, BUTTON_TYPE, DSButton, DSModal } from '@repo/design-system/index'
import { useQueryClient } from '@tanstack/react-query'
import { useEffect } from 'react'
import 'react-reflex/styles.css'
import { useEventTracking } from '../../../../helpers/gtmHelper'
import useAppRouter from '../../../../modules/hooks/common/useAppRouter'
import useIsWebview from '../../../../modules/hooks/common/useIsWebview'
import useReturnFullUrl from '../../../../modules/hooks/webview/common/useReturnFullUrl'
import useWebviewNavigation from '../../../../modules/hooks/webview/common/useWebviewNavigation'
import { n_common, n_lesson_prep } from '../../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../../modules/i18n/useTranslation'
import { COLORS } from '../../../../modules/vars'

const PreparationNotYet = ({ showPrepPopup, setShowPrepPopup, handlePrepPopupClose }) => {
  const router = useAppRouter()
  const { popBackToRingleApp } = useWebviewNavigation()
  const { sendPageViewEvent } = useEventTracking()
  const isWebview = useIsWebview()
  const getFullUrl = useReturnFullUrl()

  const { t } = useTranslation()

  const queryClient = useQueryClient()

  useEffect(() => {
    if (!router) return
    if (!showPrepPopup) return
    sendPageViewEvent({ page_name: 'lesson_prep_exit_warning' })
  }, [router.asPath])

  return (
    <DSModal id="TextOnlySMTwoButtonHorizontalPopup" isOpen={showPrepPopup} setIsOpen={setShowPrepPopup} size="lg">
      <DSModal.Title>{t(n_lesson_prep.popup_leave_title)}</DSModal.Title>
      <DSModal.Content>{t(n_lesson_prep.popup_leave_info)}</DSModal.Content>
      <DSModal.ButtonContainer direction="horizontal">
        <DSButton
          size={BUTTON_SIZE.MD}
          type={BUTTON_TYPE.OUTLINE}
          customBgColor={COLORS.WHITE}
          onClick={handlePrepPopupClose}
        >
          <DSButton.Label>{t(n_common.btn_continue)}</DSButton.Label>
        </DSButton>

        <DSButton
          onClick={() => {
            if (isWebview) {
              popBackToRingleApp()
            } else {
              // router.push(urls.student.newPortal.lessons.upcomingLessons)
              router.back()
            }
          }}
          size={BUTTON_SIZE.MD}
          type={BUTTON_TYPE.SOLID}
        >
          <DSButton.Label>{t(n_common.btn_leave)}</DSButton.Label>
        </DSButton>
      </DSModal.ButtonContainer>
    </DSModal>
  )
}

export default PreparationNotYet
